import { StrictMode, Suspense, lazy } from 'react';
import { createRoot } from 'react-dom/client';
import { registerSW } from 'virtual:pwa-register';
import App from './App.jsx';
import EnvBanner from './components/EnvBanner.jsx';
import { IS_NATIVE } from './native/platform.js';
import './index.css';

// Sprint App native — Lot 3. Passerelle native (version minimale, connexion
// PKCE, refresh silencieux) chargée à la demande : en build web, `IS_NATIVE`
// vaut `false` au build et ce chunk (plugins Capacitor) n'est pas émis.
const NativeGate = IS_NATIVE ? lazy(() => import('./native/NativeGate.jsx')) : null;

// Service Worker — mise à jour automatique sans hard-reload manuel.
// En mode `autoUpdate`, dès qu'un nouveau bundle est détecté le SW prend le
// contrôle (skipWaiting + clientsClaim) et la page se recharge. On ajoute une
// vérification périodique (+ au retour de focus) pour que les onglets DÉJÀ
// ouverts récupèrent une nouvelle mise en prod sans intervention de
// l'utilisateur (corrige la dette « cache SW » : plus de hard-reload requis).
// App native : JAMAIS de Service Worker (fichiers servis localement par la
// coquille ; un SW ne ferait que figer un bundle périmé).
const updateSW = IS_NATIVE ? null : registerSW({
  immediate: true,
  onNeedRefresh() {
    // Filet de sécurité si l'auto-reload ne se déclenche pas : applique + recharge.
    updateSW(true);
  },
  onRegisteredSW(_swUrl, registration) {
    if (!registration) return;
    const check = () => registration.update().catch(() => {});
    setInterval(check, 60 * 1000); // toutes les 60 s
    document.addEventListener('visibilitychange', () => {
      if (document.visibilityState === 'visible') check();
    });
  },
});

// Fond aux couleurs de l'app pendant le chargement du chunk natif : un `null`
// laissait la WebView vide (écran noir).
const NATIVE_LOADING = <div style={{ minHeight: '100dvh', background: 'var(--bg)' }} />;

createRoot(document.getElementById('root')).render(
  <StrictMode>
    <EnvBanner />
    {IS_NATIVE ? (
      <Suspense fallback={NATIVE_LOADING}>
        <NativeGate>
          <App />
        </NativeGate>
      </Suspense>
    ) : (
      <App />
    )}
  </StrictMode>,
);
